import * as React from 'react';

function DeviceGroupsIcon({ color = '#545454', ...props }) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M5.622 13.242v-3.047a3.809 3.809 0 117.617 0v3.047m-9.14 0h10.663c.841 0 1.523.682 1.523 1.523v5.332c0 .842-.682 1.524-1.523 1.524H4.098a1.523 1.523 0 01-1.523-1.523v-5.332c0-.842.682-1.524 1.523-1.524zM20.06 17.91c.84 0 1.523-.681 1.523-1.523v-5.332c0-.841-.682-1.523-1.524-1.523h-3.297m1.774 0V6.485a3.808 3.808 0 00-6.175-2.984'
				stroke={color}
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default DeviceGroupsIcon;
